import React from 'react'
import "./SubStyle.css"

const CQC_Occupancy = () => {
  return (
    <section className="SubServices">
     <h1 className="SubServices-title">Maximising Occupancy</h1>
      <p className="SubServices-pera">Maintaining strong occupancy levels is key to the success and sustainability of any care service. We help you develop effective marketing strategies, strengthen referral relationships, improve service visibility, and enhance resident experiences to increase enquiries and occupancy rates.</p>
         <div className="btn-container">
        <button className="SubServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default CQC_Occupancy
